export default __webpack_public_path__ + "static/comparisons-app-creation-1b1af9fec093c1f454cb83b38cd99923.gif";